'use client'

export default function loading() {
    return (
        <div className='h-dvh flex flex-col'>
           
            <div className='flex flex-col gap-5 '>
                <div className='animate-pulse bg-gray-200 rounded-2xl aspect-[5/1] w-full'>

                </div>
                <div className='animate-pulse bg-gray-200 rounded-2xl aspect-[1.75/1] w-full'>

                </div>
                <div className='animate-pulse bg-gray-200 rounded-2xl aspect-[1.75/1] w-full'>

                </div>
                <div className='animate-pulse bg-gray-200 rounded-2xl aspect-[1.75/1] w-full'>

                </div>
            </div>
        </div>
    );
}